import { render } from "./encase.vue?vue&type=template&id=f25149ee&scoped=true"
import script from "./encase.vue?vue&type=script&lang=js"
export * from "./encase.vue?vue&type=script&lang=js"

import "./encase.vue?vue&type=style&index=0&id=f25149ee&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f25149ee"]])

export default __exports__